import React from 'react';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';
import { SelectionOrderFilters } from '../../../../app/models/SelectionOrder';

interface Props {
  filter: SelectionOrderFilters;
  setFilter: (filter: SelectionOrderFilters) => void;
  onSearch: () => void;
}

const SelectionOrderFilter = ({ filter, setFilter, onSearch }: Props) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value
    });
  };

  const doSearch = () => {
    onSearch();
  };

  return (
    <div className="row">
      <div className="row">
        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Estado</label>
            <select
              name="status"
              className="form-control form-control-sm"
              value={filter.status ?? ''}
              onChange={handleChange}
            >
              <option value="">Todos</option>
              <option value="CREATED">Creado</option>
              <option value="IN_PROGRESS">En progreso</option>
              <option value="FINALIZED">Finalizado</option>
              <option value="ANNULLED">Anulado</option>
            </select>
          </div>
        </div>

        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Prog. desde</label>
            <input
              type="date"
              name="program_date_from"
              className="form-control form-control-sm"
              value={filter.program_date_from ?? ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Prog. hasta</label>
            <input
              type="date"
              name="program_date_to"
              className="form-control form-control-sm"
              value={filter.program_date_to ?? ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Inicio desde</label>
            <input
              type="date"
              name="start_date_from"
              className="form-control form-control-sm"
              value={filter.start_date_from ?? ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-auto">
          <div className="mb-3">
            <label className="font-size-10 mb-1">Inicio hasta</label>
            <input
              type="date"
              name="start_date_to"
              className="form-control form-control-sm"
              value={filter.start_date_to ?? ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="col-md-auto">
          <div style={{ marginTop: '22px' }}>
            <ButtonSearchFilter callbackSearch={doSearch} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectionOrderFilter;

